<main-header class="row"></main-header>

<div [hidden]="userIsConnected">
<app-login (signin)="afterLogin($event)"></app-login>
</div>
    
<div id="main-zone" class="row" *ngIf="userIsConnected">
    <main-toolbar *ngIf="gd.toollist!=null"></main-toolbar>
    <main-menu class="col-1 side" (change)="changeRubric($event)"></main-menu>
    <div id="content" [class]="gd.truelyShowBuildingChooser ? 'col-9' : 'col-11'" *ngIf="ready">
        <router-outlet></router-outlet>
    </div>
    <main-building-choose class="col-2" *ngIf="ready && gd.truelyShowBuildingChooser">
    </main-building-choose>
</div>